import './css/jobliner.css';

const inlineStyle = {
    backgroundColor: 'blue'
};

const Jobliner = (props) =>

    (
        <div className='jobliner-container'>    
            <div className="jobliner-icon" style={props.style}><img src={props.logo} width="32px;"/></div>
            <div className='spacer-1'></div>
            <div className="jobliner-data">{props.text}</div>
        </div>
    );

export default Jobliner;